import type { TipoOperacionCatalogo } from '../types/solicitudWeb'

/**
 * Catálogo de RESPALDO: solo se usa si la API no responde.
 * El catálogo de verdad está en la API (notariasmvc/NotariasWebs/Solicitudes/catalogo-solicitud-web.json)
 * y cada notaría puede personalizar su documentación desde el panel.
 * Si se cambia el JSON de la API, conviene actualizar también este archivo.
 */
export const CATALOGO_TIPOS: TipoOperacionCatalogo[] = [
  {
    codigo: 'COMPRAVENTA',
    pideNie: true,
    nombre: 'Compraventa',
    descripcion: 'Comprar o vender una vivienda, local, garaje o terreno.',
    icono: 'mdi-home-switch-outline',
    llevaBienes: true,
    permiteOtrosIntervinientes: true,
    roles: [
      { codigo: 'COMPRADOR', nombre: 'Comprador' },
      { codigo: 'VENDEDOR', nombre: 'Vendedor' }
    ],
    rolSolicitantePorDefecto: 'COMPRADOR',
    documentos: [
      { nombre: 'DNI o NIE de todos los intervinientes', obligatorio: true },
      { nombre: 'Escritura de propiedad del vendedor', obligatorio: true },
      { nombre: 'Último recibo del IBI', obligatorio: true },
      { nombre: 'Certificado de eficiencia energética', obligatorio: true },
      { nombre: 'Certificado de la comunidad de propietarios', obligatorio: false }
    ]
  },
  {
    codigo: 'HIPOTECA',
    pideNie: true,
    nombre: 'Préstamo hipotecario',
    descripcion: 'Firmar, ampliar o cancelar una hipoteca.',
    icono: 'mdi-bank-outline',
    llevaBienes: true,
    permiteOtrosIntervinientes: true,
    roles: [
      { codigo: 'PRESTATARIO', nombre: 'Prestatario' },
      { codigo: 'AVALISTA', nombre: 'Avalista' },
      { codigo: 'HIPOTECANTE', nombre: 'Hipotecante no deudor' }
    ],
    rolSolicitantePorDefecto: 'PRESTATARIO',
    documentos: [
      { nombre: 'DNI o NIE de todos los intervinientes', obligatorio: true },
      { nombre: 'Escritura de propiedad', obligatorio: true },
      { nombre: 'Oferta vinculante (FEIN) del banco', obligatorio: false }
    ]
  },
  {
    codigo: 'HERENCIA',
    pideNie: true,
    nombre: 'Herencia',
    descripcion: 'Aceptar y repartir la herencia de un familiar.',
    icono: 'mdi-account-group-outline',
    llevaBienes: true,
    permiteOtrosIntervinientes: true,
    roles: [
      { codigo: 'HEREDERO', nombre: 'Heredero' },
      { codigo: 'LEGATARIO', nombre: 'Legatario' },
      { codigo: 'CONYUGE_VIUDO', nombre: 'Cónyuge viudo/a' }
    ],
    rolSolicitantePorDefecto: 'HEREDERO',
    documentos: [
      { nombre: 'Certificado de defunción', obligatorio: true },
      { nombre: 'Certificado de últimas voluntades', obligatorio: true },
      { nombre: 'Copia del testamento (si lo hay)', obligatorio: false },
      { nombre: 'Escrituras o recibos del IBI de los inmuebles', obligatorio: false },
      { nombre: 'Saldos bancarios a fecha de fallecimiento', obligatorio: false }
    ]
  },
  {
    codigo: 'TESTAMENTO',
    nombre: 'Testamento',
    descripcion: 'Hacer o modificar su testamento.',
    icono: 'mdi-file-sign',
    llevaBienes: false,
    permiteOtrosIntervinientes: false,
    roles: [{ codigo: 'TESTADOR', nombre: 'Testador' }],
    rolSolicitantePorDefecto: 'TESTADOR',
    documentos: [{ nombre: 'DNI o NIE en vigor', obligatorio: true }]
  },
  {
    codigo: 'PODER',
    admiteVideoconferencia: true,
    nombre: 'Poder',
    descripcion: 'Autorizar a otra persona para que actúe en su nombre.',
    icono: 'mdi-account-key-outline',
    llevaBienes: false,
    permiteOtrosIntervinientes: true,
    roles: [
      { codigo: 'PODERDANTE', nombre: 'Quien da el poder' },
      { codigo: 'APODERADO', nombre: 'Quien recibe el poder' }
    ],
    rolSolicitantePorDefecto: 'PODERDANTE',
    documentos: [
      { nombre: 'DNI o NIE de quien da el poder', obligatorio: true },
      { nombre: 'Datos de la persona apoderada', obligatorio: true }
    ]
  },
  {
    codigo: 'DONACION',
    pideNie: true,
    nombre: 'Donación',
    descripcion: 'Donar dinero o un inmueble, por ejemplo a un hijo.',
    icono: 'mdi-gift-outline',
    llevaBienes: true,
    permiteOtrosIntervinientes: true,
    roles: [
      { codigo: 'DONANTE', nombre: 'Donante' },
      { codigo: 'DONATARIO', nombre: 'Donatario' }
    ],
    rolSolicitantePorDefecto: 'DONANTE',
    documentos: [
      { nombre: 'DNI o NIE de todos los intervinientes', obligatorio: true },
      { nombre: 'Escritura del inmueble o justificante del dinero', obligatorio: true }
    ]
  },
  {
    codigo: 'SOCIEDAD',
    admiteVideoconferencia: true,
    pideNie: true,
    nombre: 'Sociedades',
    descripcion: 'Constituir una sociedad, ampliar capital, nombrar cargos…',
    icono: 'mdi-domain',
    llevaBienes: false,
    permiteOtrosIntervinientes: true,
    roles: [
      { codigo: 'SOCIO', nombre: 'Socio' },
      { codigo: 'ADMINISTRADOR', nombre: 'Administrador' }
    ],
    rolSolicitantePorDefecto: 'SOCIO',
    documentos: [
      { nombre: 'DNI o NIE de los socios', obligatorio: true },
      { nombre: 'Certificación negativa de denominación', obligatorio: false }
    ]
  },
  {
    codigo: 'MATRIMONIO',
    nombre: 'Matrimonio y capitulaciones',
    descripcion: 'Casarse ante notario, pareja de hecho, capitulaciones matrimoniales o separación de bienes.',
    icono: 'mdi-ring',
    llevaBienes: false,
    permiteOtrosIntervinientes: true,
    roles: [{ codigo: 'CONYUGE', nombre: 'Cónyuge o pareja' }],
    rolSolicitantePorDefecto: 'CONYUGE',
    documentos: [
      { nombre: 'DNI, NIE o pasaporte de ambas personas', obligatorio: true },
      { nombre: 'Capitulaciones o documento anterior, si existe', obligatorio: false }
    ]
  },
  {
    codigo: 'EXTRANJERIA',
    nombre: 'Extranjería y nacionalidad',
    descripcion: 'Jura de nacionalidad, manifestaciones y documentos para trámites de extranjería.',
    icono: 'mdi-passport',
    llevaBienes: false,
    permiteOtrosIntervinientes: true,
    roles: [{ codigo: 'INTERESADO', nombre: 'Interesado' }],
    rolSolicitantePorDefecto: 'INTERESADO',
    documentos: [
      { nombre: 'Pasaporte o NIE en vigor', obligatorio: true },
      { nombre: 'Documento que le ha pedido la administración, si lo tiene', obligatorio: false }
    ]
  },
  {
    codigo: 'ACTAS',
    admiteVideoconferencia: true,
    nombre: 'Actas y otros documentos notariales',
    descripcion: 'Actas, legitimaciones, apostillas, compulsas u otra constancia notarial.',
    icono: 'mdi-file-sign',
    llevaBienes: false,
    permiteOtrosIntervinientes: true,
    roles: [{ codigo: 'INTERESADO', nombre: 'Interesado' }],
    rolSolicitantePorDefecto: 'INTERESADO',
    documentos: [
      { nombre: 'DNI o NIE en vigor', obligatorio: true },
      { nombre: 'Documento o copia sobre el que se pide, si lo hay', obligatorio: false }
    ]
  },
  {
    codigo: 'OTRO',
    nombre: 'Otro encargo',
    descripcion: 'Actas, pólizas, capitulaciones u otra consulta.',
    icono: 'mdi-dots-horizontal-circle-outline',
    llevaBienes: false,
    permiteOtrosIntervinientes: true,
    roles: [{ codigo: 'INTERESADO', nombre: 'Interesado' }],
    rolSolicitantePorDefecto: 'INTERESADO',
    documentos: [{ nombre: 'DNI o NIE en vigor', obligatorio: true }]
  }
]
